import React from 'react'

import OfficeOptionLabel from '@/components/integration/nylas/scheduler/components/meetingFormatPicker/OfficeOptionLabel'
import { useSchedulerConfig } from '@/components/integration/nylas/scheduler/context/SchedulerConfigContext'
import { useSchedulerSelection } from '@/components/integration/nylas/scheduler/context/SchedulerSelectionContext'
import { Label } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { MEETING_FORMAT } from '@/lib/constants'

/**
 * Lets the client choose which office to meet at. The API only returns offices
 * that can still be offered.
 */
const InPersonLocationPicker: React.FC = () => {
  const { availableLocations = [] } = useSchedulerConfig()
  const { selectedFormat, selectedLocationId, setSelectedLocationId } =
    useSchedulerSelection()

  const shouldShow =
    selectedFormat === MEETING_FORMAT.in_person_office &&
    availableLocations.length > 0

  if (!shouldShow) {
    return false
  }

  return (
    <div className="mb-6 flex flex-col gap-2">
      <Label htmlFor="scheduler-office">Office</Label>

      <Select
        value={selectedLocationId?.toString() ?? ''}
        onValueChange={(locationId) =>
          setSelectedLocationId(Number(locationId))
        }
      >
        <SelectTrigger id="scheduler-office" className="w-full">
          <SelectValue placeholder="Select an office" />
        </SelectTrigger>

        <SelectContent>
          {availableLocations.map((location) => (
            <SelectItem key={location.id} value={String(location.id)}>
              <OfficeOptionLabel location={location} />
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <p className="text-muted-foreground mb-0 text-xs">
        {selectedLocationId === null
          ? 'Select an office to see the available times.'
          : 'Times below are for advisers based at this office.'}
      </p>
    </div>
  )
}

export default InPersonLocationPicker
